import React from "react";
import "../details-container/styles.css";
import AccountsIcon from "../../icons/accounts-icon.js";
import Text from "../typography/text.js";
import DistributorIcon from "../../icons/distributor-icon.js";
import ManufacturerIcon from "../../icons/manufacturer-icon.js";
import CalenderIcon from "../../icons/calender-icon.js";
import AsUsersIcon from "../../icons/as-users-icon.js";
import { useNavigate } from "react-router-dom";
import Button from "../button/button.js";
import InvoicesIcon from "../../icons/invoices-icon.js";
import APIService from "../../Service/APIService.js";
import axios from "axios";
import { message } from "antd";

const DetailsContainer = ({
  firstHeading = "Account",
  secondHeading = "Distributor",
  secondIcon,
  thirdHeading = "Manufacturer",
  thirdIcon,
  rightFirstHeading,
  rightSecondHeading,
  fourthIcon,
  fourthHeading,
  fourthValue,
  accountName,
  childAccount,
  isChild,
  distributorName,
  manufacturerName,
  manufacturerNameOnly,
  invoiceDate,
  invoiceDue,
  accountID,
  distributorID,
  manufacturerID,
  downloadInvoiceFileName,
  downloadInvoiceFileBlobName,
  onViewAllInvoiceFiles,
  showInvoiceFilesLink = false,
  rightComponent = true,
  additionalDataFirst,
  additionalDataSecond,
  showRightFirstIcon=true,
  showRightSecondIcon=true,
  showRightThirdIcon=true,
  rightThirdHeading="Submitted By",
  submittedBy,
  showRightThirdSection = true,
  accountPath,
  distributorPath,
  style,
  primaryInsurance,
  secondaryInsurance,
  showInsurance = false,
  primaryInsuranceHeading = "Primary Insurance",
  secondaryInsuranceHeading = "Secondary Insurance"
}) => {
  const navigate = useNavigate();
  const downloadInvoice = async () => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(downloadInvoiceFileBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }

    try {
      const response = await axios.get(sasUrl, {
        responseType: "blob",
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", downloadInvoiceFileName); // specify file name and extension
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url); // clean up
    } catch (error) {
      message.error("Error downloading file.");
      console.error(error);
    }
  };

  return (
    <div className="details-container" style={style}>
      <div className="details-container-left">
        <div className="details-container-left-section">
          <div className="details-title-container">
            <AccountsIcon className="icon-container" />
            <Text variant="tinyText" color="lightText">
              {firstHeading}
            </Text>
          </div>
          {/* <div
            onClick={() => navigate(`/Account/${accountID}`)}
            style={{ cursor: "pointer" }}
          >
            <Text variant="bodyText" className="details-container-text-section">
              {accountName}
            </Text>
          </div> */}
          <Button
            variant="link"
            onClick={() => navigate(`/Account/${accountID}`)}
          >
            {accountName}
          </Button>
          {isChild ? (
            <Text variant="tinyText" color="lightText">
              {childAccount}
            </Text>
          ) : null}
          {additionalDataFirst && (
            <Text variant="tinyText" color="lightText">
              {additionalDataFirst}
            </Text>
          )}
        </div>
        <div className="details-container-left-section">
          <div className="details-title-container">
            {secondIcon ?? <DistributorIcon className="icon-container" />}
            <Text variant="tinyText" color="lightText">
              {secondHeading}
            </Text>
          </div>
          {/* <div
            onClick={() => navigate(`/Distributor/${distributorID}`)}
            style={{ cursor: "pointer" }}
          >
            <Text variant="bodyText" className="details-container-text-section">
              {distributorName}
            </Text>
          </div> */}
          <Button
            variant="link"
            onClick={() => navigate(`/${accountPath ?? "Distributor"}/${distributorID}`)}
          >
            {distributorName}
          </Button>
          {additionalDataSecond && (
            <Text variant="tinyText" color="lightText">
              {additionalDataSecond}
            </Text>
          )}
        </div>
        <div className="details-container-left-section">
          <div className="details-title-container">
            {thirdIcon ?? <ManufacturerIcon className="icon-container" />}
            <Text variant="tinyText" color="lightText">
              {thirdHeading}
            </Text>
          </div>
          {manufacturerNameOnly ? (
            <div>
              <Text
                variant="smallText"
                className="details-container-text-section"
              >
                {manufacturerName}
              </Text>
            </div>
          ) : (
            <Button
              variant="link"
              onClick={() => navigate(`/${distributorPath ?? "Manufacturer"}/${manufacturerID}`)}
            >
              {manufacturerName}
            </Button>
          )}
        </div>
        {showInsurance && (
          <>
            <div className="details-container-left-section">
              <div className="details-title-container">
                <InvoicesIcon className="icon-container" />
                <Text variant="tinyText" color="lightText">
                  {primaryInsuranceHeading}
                </Text>
              </div>
              <Text variant="bodyText" className="details-container-text-section">
                {primaryInsurance || "N/A"}
              </Text>
            </div>
            <div className="details-container-left-section">
              <div className="details-title-container">
                <InvoicesIcon className="icon-container" />
                <Text variant="tinyText" color="lightText">
                  {secondaryInsuranceHeading}
                </Text>
              </div>
              <Text variant="bodyText" className="details-container-text-section">
                {secondaryInsurance || "N/A"}
              </Text>
            </div>
          </>
        )}
        {fourthHeading && (
          <div className="details-container-left-section">
            <div className="details-title-container">
              {fourthIcon ?? <DistributorIcon className="icon-container" />}
              <Text variant="tinyText" color="lightText">
                {fourthHeading}
              </Text>
            </div>
            <Button variant="link">{fourthValue}</Button>
          </div>
        )}
        {downloadInvoiceFileName && (
          <div className="details-container-left-section">
            <div className="details-title-container">
              <InvoicesIcon className="icon-container" />
              <Text variant="tinyText" color="lightText">
                Download Invoice
              </Text>
              {showInvoiceFilesLink && onViewAllInvoiceFiles ? (
                <button
                  type="button"
                  className="details-inline-link-button"
                  onClick={onViewAllInvoiceFiles}
                >
                  see all
                </button>
              ) : null}
            </div>
            <Button
              variant="link"
              // onClick={() => navigate(`/Manufacturer/${manufacturerID}`)}
              onClick={downloadInvoice}
            >
              {downloadInvoiceFileName || "Download Invoice"}
            </Button>
          </div>
        )}
      </div>
      {rightComponent ? (
        <div className="details-container-left">
          <div className="details-container-left-section">
            <div className="details-title-container">
              {showRightFirstIcon && <CalenderIcon className="icon-container" />}
              <Text variant="tinyText" color="lightText">
                {rightFirstHeading}
              </Text>
            </div>
            <Text variant="bodyText" className="details-container-text-section">
              {invoiceDate}
            </Text>
          </div>
          <div className="details-container-left-section">
            <div className="details-title-container">
              {showRightSecondIcon && <CalenderIcon className="icon-container" />}
              <Text variant="tinyText" color="lightText">
                {rightSecondHeading}
              </Text>
            </div>
            <Text variant="bodyText" className="details-container-text-section">
              {invoiceDue}
            </Text>
          </div>
          {showRightThirdSection && (
            <div className="details-container-left-section">
              <div className="details-title-container">
                {showRightThirdIcon && <AsUsersIcon className="icon-container" />}
                <Text variant="tinyText" color="lightText">
                  {rightThirdHeading}
                </Text>
              </div>
              <Text variant="bodyText" className="details-container-text-section">
                {submittedBy}
              </Text>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default DetailsContainer;
